module.exports = __webpack_public_path__ + "static/img/SpecialSSD-BFrVTRHJ.967086c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/SpecialSSD-BFrVTRHJ.png
// module id = /Xwm
// module chunks = 16